import { Box, Typography } from '@mui/material'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import RenderServiceIcon from 'components/RenderServiceIcons/RenderServiceIcon'
import { formatCurrency } from 'components/DataGrid/operators/formatNumbers'
import { OrganizationTableItem } from 'types/organizations_table'
import { formatDateString } from 'utils/formatDayjsDateTime'

const formatPercentage = (num: number) => `${Math.round(num)}%`

const ProductItem = ({ option, minimize }: { option: OrganizationTableItem; minimize?: boolean | false }) => {
  return (
    <Box
      key={option?.SK}
      sx={{
        display: 'grid',
        alignItems: 'center',
        columnGap: 1,
        width: '100%',
        // ✅ fixed “table-like” columns:
        gridTemplateColumns: `
              minmax(150px, 1fr)
              60px
              60px
              60px
              90px
              90px
              70px
            `,
      }}
    >
      {/* Name */}
      <Box sx={{ minWidth: 0 }}>
        <RenderServiceIcon
          service={option?.title || option?.productName}
          size={{ height: 14, width: 14, fontSize: 12, marginLeft: 0 }}
        />
      </Box>
      <Typography
        noWrap
        sx={{
          textAlign: 'right',
          fontSize: 12,
          color: renderColorByString(option.category_name || option.category || null),
        }}
      >
        {option.category_name || option.category || 'No category'}
      </Typography>
      {/* Price */}
      <Typography noWrap sx={{ textAlign: 'right', fontSize: 12 }}>
        {option?.price ? formatCurrency(parseFloat(option?.price)) : '$0.00'}
      </Typography>
      <Typography noWrap sx={{ textAlign: 'right', fontSize: 12 }}>
        {option?.margin ? formatPercentage(parseFloat(option?.margin)) : '$0.00'}
      </Typography>
      {!minimize && (
        <>
          <Typography noWrap sx={{ textAlign: 'right', fontSize: 12 }}>
            {option?.startDate ? formatDateString(option?.startDate) : '–'}
          </Typography>

          <Typography
            noWrap
            sx={{
              textAlign: 'right',
              fontSize: 12,
              position: 'relative',
            }}
          >
            <Box component="span" sx={{ mr: 0.5, color: 'text.disabled' }}>
              →
            </Box>
            {option?.endDate ? formatDateString(option?.endDate) : '–'}
          </Typography>
          <Typography noWrap sx={{ textAlign: 'right', fontSize: 12, color: renderColorByString(option.status) }}>
            {option.status || 'No Status'}
          </Typography>
        </>
      )}
    </Box>
  )
}

export default ProductItem
